import type { App, Component } from 'vue'
import * as ConfiguredIcons from '@/config/icons.ts'

export const AllIcons: Record<keyof typeof ConfiguredIcons, Component> = ConfiguredIcons

export function ToIcon(data: string | Component | undefined): Component | undefined {
  if (!data) return undefined
  if (typeof data == 'string') return AllIcons[data]
  return toRaw(data)
}

export default {
  install: (app: App) => {
    app.config.globalProperties.$icons = AllIcons

    for (const iconName of Object.keys(ConfiguredIcons)) {
      app.component(iconName, ConfiguredIcons[iconName])
    }
  }
}
